import { type BlokProps, StoryblokComponentList } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import { AccordionRoot } from "@/components/ui/Accordion";
import type { BlokAccordion } from "@/storyblok";
import styles from "./AccordionBlok.module.css";

export const AccordionBlok = ({ blok, preview }: BlokProps<BlokAccordion>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<AccordionRoot className={styles.root} data-full-width={blok.fullWidth}>
				{blok.items && (
					<StoryblokComponentList bloks={blok.items} preview={preview} />
				)}
			</AccordionRoot>
		</BlokWrap>
	);
};
